export const name = 'rnInstructionsService';
export default function rnInstructionsService(
  $injector,
  $q
) {
  'ngInject';

  const URL = 'url';
  const SVG_ICON = 'svg';

  const MODEL_TYPES = {
    LatexPrinter: {
      'M0E30A': 'LatexLV',
      '1QE01A': 'LatexLV2',
      '1QE01B': 'LatexLV2',
      '1QE01C': 'LatexLV2',
      '1QE01D': 'LatexLV2',
      'B4H69A': 'LatexLV2',
      'V7L46A': 'LatexLV2',
      'V7L46B': 'LatexLV2',
      'V7L46C': 'LatexLV2',
      'V7L46D': 'LatexLV2',
      'E2X76A': 'LatexLV2',
      'V7L47A': 'LatexLV2',
      'V7L47B': 'LatexLV2',
      'V7L47C': 'LatexLV2',
      'V7L47D': 'LatexLV2',
      'B4H70A': 'LatexLV2',
      'V8L39A': 'LatexLV2',
      'V8L39B': 'LatexLV2',
      'V8L39C': 'LatexLV2',
      'V8L39D': 'LatexLV2',
      'L4R41A': 'LatexLV2',
      'V8N83A': 'LatexLV2',
      'V8N83B': 'LatexLV2',
      'V8N83C': 'LatexLV2',
      'V8N83D': 'LatexLV2',
      'M0E29A': 'LatexLV',
      'M0E29B': 'LatexLV',
      'M0E29C': 'LatexLV',
      'M0E29D': 'LatexLV',
      'N2G70A': 'LatexLV',
      'N2G70B': 'LatexLV',
      'N2G70C': 'LatexLV',
      'N2G70D': 'LatexLV',
      'K4T88A': 'LatexMV',
      'CZ056A': 'LatexMV',
      'L2E27A': 'LatexMV',
      '1HA06A': 'LatexMV',
      'K4G10A': 'LatexMV',
      '1HA07A': 'LatexMV',
      '1HA07B': 'LatexMV',
      '3DB03A': 'LatexMV',
      'K0Q45A': 'LatexR',
      'K0Q46A': 'LatexR',
      'K0Q47A': 'LatexR',
      'K0Q48A': 'LatexR',
      '3R745A': 'LatexR',
      '3R743A': 'LatexR',
      '3R745C': 'LatexR',
      '3R743C': 'LatexR',
      '3R745D': 'LatexR',
      '3R743D': 'LatexR',
      '69G27A': 'LatexR',
      '9T922A': 'LatexR',
      '9T923A': 'LatexR',
      '9T924A': 'LatexR',
      '9T925A': 'LatexR',
      '9T922C': 'LatexR',
      '9T923C': 'LatexR',
      '9T924C': 'LatexR',
      '9T925C': 'LatexR',
      'Y0U22A': 'DesignJet',
      'Y0U22B': 'DesignJet',
      'Y0U22F': 'DesignJet',
      'Y0U23A': 'DesignJet',
      'Y0U23B': 'DesignJet',
      'Y0U23F': 'DesignJet',
      'Y0U21A': 'DesignJet',
      'Y0U21B': 'DesignJet',
      'Y0U21F': 'DesignJet',
      '3XD61A': 'DesignJet',
      '3XD61B': 'DesignJet',
      '3XD61F': 'DesignJet',
      '870B7A': 'DesignJet',
      '870B7B': 'DesignJet',
      '870B7F': 'DesignJet',
      '870B8A': 'DesignJet',
      '870B8B': 'DesignJet',
      '870B8F': 'DesignJet',
      '870B9A': 'DesignJet',
      '870B9B': 'DesignJet',
      '870B9F': 'DesignJet',
      '870C0A': 'DesignJet',
      '870C0B': 'DesignJet',
      '870C0F': 'DesignJet',
      '171S2A': 'LatexDune',
      '171K3A': 'LatexDune',
      '171K6A': 'LatexDune',
      '171S2B': 'LatexDune',
      '171K3B': 'LatexDune',
      '171K6B': 'LatexDune',
      '171S2F': 'LatexDune',
      '171K3F': 'LatexDune',
      '171K6F': 'LatexDune',
    },
    TextilePrinter: {
      '2ET72A': 'Textile',
      '2ET73A': 'Textile',
      '2ET73B': 'Textile',
      '4DC17A': 'TextileMV',
      '1D3A8A': 'TextileMV',
    },
    DesignjetPrinter: {
      'T8W15A': 'DesignJet',
      'T8W15B': 'DesignJet',
      'T8W16A': 'DesignJet',
      'T8W18A': 'DesignJet',
      'T8W18B': 'DesignJet',
      'W3Z71A': 'DesignJet',
      'W3Z72A': 'DesignJet',
      'W3Z71B': 'DesignJet',
      'X9D24A': 'DesignJet',
      'X9D24B': 'DesignJet',
      'T8W15D': 'DesignJet',
      'T8W16D': 'DesignJet',
      'W3Z71D': 'DesignJet',
      '2RM82A': 'DesignJet',
      '2QU25A': 'DesignJet',
	    '2RM82F': 'DesignJet',
      '2QU25F': 'DesignJet',
      '6KD23A': 'DesignJet',
      '6KD23H': 'DesignJet',
      '6KD24A': 'DesignJet',
      '6KD24F': 'DesignJet',
      '6KD24H': 'DesignJet',
      '6KD25A': 'DesignJet',
      '6KD25H': 'DesignJet',
      '6KD26A': 'DesignJet',
      '6KD26F': 'DesignJet',
      '6KD26H': 'DesignJet',
      '7QR88A': 'DesignJetDune',
      '7QR88B': 'DesignJetDune',
      '7QR88F': 'DesignJetDune',
      '7QR88G': 'DesignJetDune',
      '7QR88H': 'DesignJetDune',
      '7QR88M': 'DesignJetDune',
      '7QR88S': 'DesignJetDune',
    },
    PageWideXLPrinter: {
      '4VW19A': 'DesignJet',
      '4VW19F': 'DesignJet',
      '4VW19H': 'DesignJet',
      '4VW20A':  'DesignJet',
      '4VW20F':  'DesignJet',
      '4VW20H':  'DesignJet',
      '4VW21A':  'DesignJet',
      '4VW21H':  'DesignJet',
    },
  };

  const INSTRUCTIONS = {

    // DesignJet
    DesignJet : {
      qr: {
        steps: [
          {key: 'devices.devices.DI_DesignJet_QR_Step1'},
          {key: 'devices.devices.DI_DesignJet_QR_Step2'},
          {key: 'devices.devices.DI_DesignJet_QR_Step3'},
          {key: 'devices.devices.DI_DesignJet_QR_Step4'},
          {key: 'devices.devices.DI_DesignJet_QR_Step5'},
          {key: 'devices.devices.DI_DesignJet_QR_Step6'},
          {key: 'devices.devices.DI_DesignJet_QR_Step7'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
      sc: {
        steps: [
          {key: 'devices.devices.DI_DesignJet_SC_Step1'},
          {key: 'devices.devices.DI_DesignJet_SC_Step2'},
          {key: 'devices.devices.DI_DesignJet_SC_Step3'},
          {key: 'devices.devices.DI_DesignJet_SC_Step4'},
          {key: 'devices.devices.DI_DesignJet_SC_Step5'},
          {key: 'devices.devices.DI_DesignJet_SC_Step6'},
          {key: 'devices.devices.DI_DesignJet_SC_Step7'},
          {key: 'devices.devices.DI_DesignJet_SC_Step8'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
      sconly: {
        steps: [
          {key: 'devices.devices.DI_DesignJet_SC_Step1'},
          {key: 'devices.devices.DI_DesignJet_SC_Step2'},
          {key: 'devices.devices.DI_DesignJet_SC_Step3'},
          {key: 'devices.devices.DI_DesignJet_SC_Step4'},
          {key: 'devices.devices.DI_DesignJet_SC_Step5'},
          {key: 'devices.devices.DI_DesignJet_SC_Step6'},
        ],
      },
    },

    // Sunspot printers
    LatexDune : {
      qr: {
        steps: [
          {key: 'devices.devices.DI_LatexDune_QR_Step1'},
          {key: 'devices.devices.DI_LatexDune_QR_Step2'},
          {key: 'devices.devices.DI_LatexDune_QR_Step3'},
          {key: 'devices.devices.DI_LatexDune_QR_Step4'},
          {key: 'devices.devices.DI_LatexDune_QR_Step5'},
          {key: 'devices.devices.DI_LatexDune_QR_Step6'},
          {key: 'devices.devices.DI_LatexDune_QR_Step7'},
          {key: 'devices.devices.DI_LatexDune_QR_Step8'},
          {key: 'devices.devices.DI_LatexDune_QR_Step9'},
          {key: 'devices.devices.DI_LatexDune_QR_Step10'},
          {key: 'devices.devices.DI_LatexDune_QR_Step11'},
          {key: 'devices.devices.DI_LatexDune_QR_Step12'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
      sc: {
        steps: [
          {key: 'devices.devices.DI_LatexDune_SC_Step1'},
          {key: 'devices.devices.DI_LatexDune_SC_Step2'},
          {key: 'devices.devices.DI_LatexDune_SC_Step3'},
          {key: 'devices.devices.DI_LatexDune_SC_Step4'},
          {key: 'devices.devices.DI_LatexDune_SC_Step5'},
          {key: 'devices.devices.DI_LatexDune_SC_Step6'},
          {key: 'devices.devices.DI_LatexDune_SC_Step7'},
          {key: 'devices.devices.DI_LatexDune_SC_Step8'},
          {key: 'devices.devices.DI_LatexDune_SC_Step9'},
          {key: 'devices.devices.DI_LatexDune_SC_Step10'},
          {key: 'devices.devices.DI_LatexDune_SC_Step11'},
          {key: 'devices.devices.DI_LatexDune_SC_Step12'},
        ],
      },
    },

    // Jupiter printers
    DesignJetDune : {
      qr: {
        steps: [
          {key: 'devices.devices.DI_LatexDune_QR_Step1'},
          {key: 'devices.devices.DI_LatexDune_QR_Step2'},
          {key: 'devices.devices.DI_LatexDune_QR_Step3'},
          {key: 'devices.devices.DI_LatexDune_QR_Step4'},
          {key: 'devices.devices.DI_LatexDune_QR_Step5'},
          {key: 'devices.devices.DI_LatexDune_QR_Step6'},
          {key: 'devices.devices.DI_LatexDune_QR_Step7'},
          {key: 'devices.devices.DI_LatexDune_QR_Step8'},
          {key: 'devices.devices.DI_LatexDune_QR_Step9'},
          {key: 'devices.devices.DI_LatexDune_QR_Step10'},
          {key: 'devices.devices.DI_LatexDune_QR_Step11'},
          {key: 'devices.devices.DI_LatexDune_QR_Step12'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
      sc: {
        steps: [
          {key: 'devices.devices.DI_LatexDune_SC_Step1'},
          {key: 'devices.devices.DI_LatexDune_SC_Step2'},
          {key: 'devices.devices.DI_LatexDune_SC_Step3'},
          {key: 'devices.devices.DI_LatexDune_SC_Step4'},
          {key: 'devices.devices.DI_LatexDune_SC_Step5'},
          {key: 'devices.devices.DI_LatexDune_SC_Step6'},
          {key: 'devices.devices.DI_LatexDune_SC_Step7'},
          {key: 'devices.devices.DI_LatexDune_SC_Step8'},
          {key: 'devices.devices.DI_LatexDune_SC_Step9'},
          {key: 'devices.devices.DI_LatexDune_SC_Step10'},
          {key: 'devices.devices.DI_LatexDune_SC_Step11'},
          {key: 'devices.devices.DI_LatexDune_SC_Step12'},
        ],
      },
    },

    // Latex 110, 115, 310, 315, 330, 335, 360, 365, 370, 375, 560, 570, 1500, 3000, 3100, 3200, 3500, 3600, 3800
    LatexLV : {
      qr: {
        steps: [
          {key: 'devices.devices.DI_LatexLV_QR_Step1'},
          {key: 'devices.devices.DI_LatexLV_QR_Step2'},
          {key: 'devices.devices.DI_LatexLV_QR_Step3'},
          {key: 'devices.devices.DI_LatexLV_QR_Step4'},
          {key: 'devices.devices.DI_LatexLV_QR_Step5'},
          {key: 'devices.devices.DI_LatexLV_QR_Step6'},
          {key: 'devices.devices.DI_LatexLV_QR_Step7'},
        ],
        notes: ['devices.devices.DI_DataAccuracyNote'],
        postActivation: {
          notes: [
            {
              key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
            {
              key: 'devices.devices.DI_DataAccuracyNote',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
          ],
        }
      },
      sc: {
        steps: [
          {key: 'devices.devices.DI_LatexLV_SC_Step1'},
          {key: 'devices.devices.DI_LatexLV_SC_Step2'},
          {key: 'devices.devices.DI_LatexLV_SC_Step3'},
          {key: 'devices.devices.DI_LatexLV_SC_Step4'},
          {key: 'devices.devices.DI_LatexLV_SC_Step5'},
          {key: 'devices.devices.DI_LatexLV_SC_Step6'},
        ],
        notes: ['devices.devices.DI_DataAccuracyNote'],
        postActivation: {
          notes: [
            {
              key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
            {
              key: 'devices.devices.DI_DataAccuracyNote',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
          ],
        }
      },
      sconly: {
        steps: [
          {key: 'devices.devices.DI_LatexLV_SC_Step1'},
          {key: 'devices.devices.DI_LatexLV_SC_Step2'},
          {key: 'devices.devices.DI_LatexLV_SC_Step3'},
          {key: 'devices.devices.DI_LatexLV_SC_Step4'},
          {key: 'devices.devices.DI_LatexLV_SC_Step5'},
        ],
      },
    },
    LatexLV2 : {
      qr: {
        steps: [
          {key: 'devices.devices.DI_LatexLV_QR_Step1'},
          {key: 'devices.devices.DI_LatexLV_QR_Step2'},
          {key: 'devices.devices.DI_LatexLV_QR_Step3'},
          {key: 'devices.devices.DI_LatexLV_QR_Step4'},
          {key: 'devices.devices.DI_LatexLV_QR_Step5'},
          {key: 'devices.devices.DI_LatexLV_QR_Step6'},
          {key: 'devices.devices.DI_LatexLV_QR_Step7'},
        ],
        notes: ['devices.devices.DI_DataAccuracyNote'],
        postActivation: {
          notes: [
            {
              key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
            {
              key: 'devices.devices.DI_DataAccuracyNote',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
          ],
        }
      },
      sc: {
        steps: [
          {key: 'devices.devices.DI_LatexLV_SC_Step1'},
          {key: 'devices.devices.DI_LatexLV_SC_Step2'},
          {key: 'devices.devices.DI_LatexLV_SC_Step3'},
          {key: 'devices.devices.DI_LatexLV_SC_Step4'},
          {key: 'devices.devices.DI_LatexLV_SC_Step5'},
          {key: 'devices.devices.DI_LatexLV_SC_Step6'},
        ],
        notes: ['devices.devices.DI_DataAccuracyNote'],
        postActivation: {
          notes: [
            {
              key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
            {
              key: 'devices.devices.DI_DataAccuracyNote',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
          ],
        }
      },
      sconly: {
        steps: [
          {key: 'devices.devices.DI_LatexLV_SC_Step1'},
          {key: 'devices.devices.DI_LatexLV_SC_Step2'},
          {key: 'devices.devices.DI_LatexLV_SC_Step3'},
          {key: 'devices.devices.DI_LatexLV_SC_Step4'},
          {key: 'devices.devices.DI_LatexLV_SC_Step5'},
        ],
      },
    },
    LatexMV : {
      qr: {
        steps: [
          {key: 'devices.devices.DI_LatexMV_QR_Step1'},
          {key: 'devices.devices.DI_LatexMV_QR_Step2'},
          {key: 'devices.devices.DI_LatexMV_QR_Step3'},
          {key: 'devices.devices.DI_LatexMV_QR_Step4'},
          {key: 'devices.devices.DI_LatexMV_QR_Step5'},
          {key: 'devices.devices.DI_LatexMV_QR_Step6'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
      sc: {
        steps: [
          {key: 'devices.devices.DI_LatexMV_SC_Step1'},
          {key: 'devices.devices.DI_LatexMV_SC_Step2'},
          {key: 'devices.devices.DI_LatexMV_SC_Step3'},
          {key: 'devices.devices.DI_LatexMV_SC_Step4'},
          {
            key: 'devices.devices.DI_LatexMV_SC_Step5',
            subSteps: [
              {
                key: 'devices.devices.DI_LatexMV_SC_Step5a',
                type: URL,
              }
            ]
          },
          {key: 'devices.devices.DI_LatexMV_SC_Step6'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
      sconly: {
        steps: [
          {key: 'devices.devices.DI_LatexMV_SC_Step1'},
          {key: 'devices.devices.DI_LatexMV_SC_Step2'},
          {key: 'devices.devices.DI_LatexMV_SC_Step3'},
          {key: 'devices.devices.DI_LatexMV_SC_Step4'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
    },
    LatexR: {
      qr: {
        steps: [
          {key: 'devices.devices.DI_LatexR_QR_Step1'},
          {
            key: 'devices.devices.DI_LatexR_QR_Step2',
            icon: {
              type: SVG_ICON,
              path: 'https://cdn.printos.com/images/general/material/settings.svg',
            }
          },
          {key: 'devices.devices.DI_LatexR_QR_Step3'},
          {key: 'devices.devices.DI_LatexR_QR_Step4'},
          {key: 'devices.devices.DI_LatexR_QR_Step5'},
          {key: 'devices.devices.DI_LatexR_QR_Step6'},
          {key: 'devices.devices.DI_LatexR_QR_Step7'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
      sc: {
        steps: [
          {
            key: 'devices.devices.DI_LatexR_SC_Step1',

          },
          {
            key: 'devices.devices.DI_LatexR_SC_Step2',
            icon: {
              type: SVG_ICON,
              path: 'https://cdn.printos.com/images/general/material/settings.svg',
            }
          },
          {key: 'devices.devices.DI_LatexR_SC_Step3'},
          {key: 'devices.devices.DI_LatexR_SC_Step4'},
          {key: 'devices.devices.DI_LatexR_SC_Step5'},
          {key: 'devices.devices.DI_LatexR_SC_Step6'},
          {key: 'devices.devices.DI_LatexR_SC_Step7'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
      sconly: {
        steps: [
          {
            key: 'devices.devices.DI_LatexR_SC_Step1',

          },
          {
            key: 'devices.devices.DI_LatexR_SC_Step2',
            icon: {
              type: SVG_ICON,
              path: 'https://cdn.printos.com/images/general/material/settings.svg',
            }
          },
          {key: 'devices.devices.DI_LatexR_SC_Step3'},
          {key: 'devices.devices.DI_LatexR_SC_Step4'},
          {key: 'devices.devices.DI_LatexR_SC_Step5'},
        ],
      }
    },
    Textile: {
      qr: {
        steps: [
          {key: 'devices.devices.DI_Textile_QR_Step1'},
          {key: 'devices.devices.DI_Textile_QR_Step2'},
          {key: 'devices.devices.DI_Textile_QR_Step3'},
          {key: 'devices.devices.DI_Textile_QR_Step4'},
          {key: 'devices.devices.DI_Textile_QR_Step5'},
          {key: 'devices.devices.DI_Textile_QR_Step6'},
          {key: 'devices.devices.DI_Textile_QR_Step7'},
          {key: 'devices.devices.DI_Textile_QR_Step8'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
        postActivation: {
          notes: [
            {
              key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
            {
              key: 'devices.devices.DI_DataAccuracyNote',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
          ],
        }
      },
      sc: {
        steps: [
          {key: 'devices.devices.DI_Textile_SC_Step1'},
          {
            key: 'devices.devices.DI_Textile_SC_Step2',
            icon: {
              type: SVG_ICON,
              path: 'https://cdn.printos.com/images/general/material/settings.svg',
            }
          },
          {key: 'devices.devices.DI_Textile_SC_Step3'},
          {key: 'devices.devices.DI_Textile_SC_Step4'},
          {key: 'devices.devices.DI_Textile_SC_Step5'},
          {key: 'devices.devices.DI_Textile_SC_Step6'},
          {key: 'devices.devices.DI_Textile_SC_Step7'},
          {key: 'devices.devices.DI_Textile_SC_Step8'},
          {key: 'devices.devices.DI_Textile_SC_Step9'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
        postActivation: {
          notes: [
            {
              key: 'devices.devices.DI_LatexLV_SN_PA_Note1',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
            {
              key: 'devices.devices.DI_DataAccuracyNote',
              icon: {
                type: SVG_ICON,
                path: 'https://cdn.printos.com/images/general/light_bulb_color.svg',
              }
            },
          ],
        }
      },
      sconly: {
        steps: [
          {key: 'devices.devices.DI_Textile_SC_Step1'},
          {
            key: 'devices.devices.DI_Textile_SC_Step2',
            icon: {
              type: SVG_ICON,
              path: 'https://cdn.printos.com/images/general/material/settings.svg',
            }
          },
          {key: 'devices.devices.DI_Textile_SC_Step3'},
          {key: 'devices.devices.DI_Textile_SC_Step4'},
          {key: 'devices.devices.DI_Textile_SC_Step5'},
          {key: 'devices.devices.DI_Textile_SC_Step6'},
          {key: 'devices.devices.DI_Textile_SC_Step7'},
        ],
      }
    },
    TextileMV : {
      qr: {
        steps: [
          {key: 'devices.devices.DI_LatexMV_QR_Step1'},
          {key: 'devices.devices.DI_LatexMV_QR_Step2'},
          {key: 'devices.devices.DI_LatexMV_QR_Step3'},
          {key: 'devices.devices.DI_LatexMV_QR_Step4'},
          {key: 'devices.devices.DI_LatexMV_QR_Step5'},
          {key: 'devices.devices.DI_LatexMV_QR_Step6'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
      sc: {
        steps: [
          {key: 'devices.devices.DI_LatexMV_SC_Step1'},
          {key: 'devices.devices.DI_LatexMV_SC_Step2'},
          {key: 'devices.devices.DI_LatexMV_SC_Step3'},
          {key: 'devices.devices.DI_LatexMV_SC_Step4'},
          {
            key: 'devices.devices.DI_LatexMV_SC_Step5',
            subSteps: [
              {
                key: 'devices.devices.DI_LatexMV_SC_Step5a',
                type: URL,
              }
            ]
          },
          {key: 'devices.devices.DI_LatexMV_SC_Step6'},
        ],
        notes: [{key: 'devices.devices.DI_DataAccuracyNote'}],
      },
      sconly: {
        steps: [
          {key: 'devices.devices.DI_LatexMV_SC_Step1'},
          {key: 'devices.devices.DI_LatexMV_SC_Step2'},
          {key: 'devices.devices.DI_LatexMV_SC_Step3'},
          {key: 'devices.devices.DI_LatexMV_SC_Step4'},
        ],
      }
    },
  };

  const service = {
    getInstructions,
    hasPostActivationInstructions,
    getPostInstructions,
    getInstallMethods,
  };
  return service;

  function getInstallMethods(type, model) {
    let methods = {
      qr: false,
      sc: false,
      sn: true
    };

    if (!_.get(MODEL_TYPES, `${type}.${model}`)) {
      return methods;
    }

    let instructions = INSTRUCTIONS[MODEL_TYPES[type][model]];
    if (instructions) {
      methods = {
        qr: instructions.qr !== undefined,
        sc: instructions.sc !== undefined,
        sn: instructions.sn !== undefined
      };
    }

    return methods;
  }

  function hasPostActivationInstructions(type, model, method) {
    if (!_.get(MODEL_TYPES, `${type}.${model}`)) {
      return false;
    }

    let instructions = INSTRUCTIONS[MODEL_TYPES[type][model]];
    if (!instructions) {
      return false;
    }

    if (!instructions[method]) {
      return false;
    }

    if (!instructions[method].postActivation) {
      return false;
    }

    return true;
  }

  function getInstructions(type, model) {
    if (!(type && model)) {
      return Promise.resolve(undefined);
    }

    let instructions = INSTRUCTIONS[MODEL_TYPES[type][model]];
    let promises = [];
    if (instructions) {
      Object.keys(instructions).forEach(method => {
        if (instructions[method].steps) {
          promises = promises.concat(doResolve(instructions[method].steps));
        }

        let postActivationSteps = _.get(instructions[method], 'postActivation.steps');
        if (postActivationSteps) {
          promises = promises.concat(doResolve(postActivationSteps));
        }
      });
    }
    return $q.all(promises).then(() => {
      return instructions;
    });
  }

  function getPostInstructions(type, model, method) {
    if (!(type && model && method)) {
      return undefined;
    }

    return getInstructions(type, model).then(instructions => {
      if (instructions && instructions[method] && instructions[method].postActivation) {
        return instructions[method].postActivation;
      }
      else {
        return undefined;
      }
    });
  }

  function doResolve(steps) {
    let promises = [];
    steps.forEach(step => {
      if (step.resolve) {
        Object.keys(step.resolve).forEach(r => {
          let promise = $injector.invoke(step.resolve[r], null, { step });
          promises.push(promise);
        });
      }

      if (step.subSteps) {
        promises = promises.concat(doResolve(step.subSteps, $injector));
      }
    });

    return promises;
  }

  // Helpers (will be invoked with $injector)
  function addLatexInternalId(rnOrganization, step) {
    'ngInject';

    return rnOrganization.getOrganization(false).then(resp => {
      let org = resp.data;
      if (!org.internalIds) {
        org.internalIds = [];
      }

      let latexInternalId = org.internalIds.find(id => id.gbu === 'Latex');
      if (latexInternalId) {
        step.values = [latexInternalId.gbuInternalId];
      }
    })
      .catch(() => {
        return Promise.resolve();
      });
  }
}
